import React from "react";
import {
  CancelBizsolWaitingButton,
  ChangeBizsolStateToWaitingButton,
  BizsolReconnectButton,
} from "@/components/atoms";
import { bizsolStateToDisplayName, isConnectedToBizsol } from "@/models";
import { BizsolState } from "@/generated/graphql";
import { useIsSpMode } from "@/hooks";
import config from "@/libs/config";
import { css } from "@emotion/react";
import { Font } from "@moneyforward/mfx_biz_react_components";

type Props = {
  state: BizsolState;
  onClickChangeToWaiting: () => void;
  onClickCancelWaiting: () => void;
  onClickReconnect: () => void;
  loading: boolean;
};

export const ChangeBizsolStateButton = ({
  state,
  onClickChangeToWaiting,
  onClickCancelWaiting,
  onClickReconnect,
  loading,
}: Props) => {
  const isSpMode = useIsSpMode();

  const isWaiting = state == BizsolState.Waiting;
  const isConnected = isConnectedToBizsol(state);
  const isUnConnected = !isWaiting && !isConnected;

  // 銀行ごとに処理を分ける
  // - 連携待・解除する: 四国銀行
  // - 未連携・連携を開始: 四国銀行
  // - 再連携: 京都信金・四国銀行

  // shikokubank
  // - waiting for link - show cancel button
  // - unconnected - show start link
  // - connected - show reconnect
  // kyoshin
  // - connected - show reconnect

  const showBizsolStateName = isConnected && config.IS_SHIKOKUBANK;
  const showCancelWaitingButton = isWaiting && config.IS_SHIKOKUBANK;
  const showChangeToWaitingButton = isUnConnected && config.IS_SHIKOKUBANK;
  const showReconnectButton =
    isConnected && (config.IS_KYOSHIN || config.IS_SHIKOKUBANK);

  return (
    <div>
      <div css={!isSpMode ? container : {}}>
        <div css={labelWrapper}>
          <Font variant="m" component="p">
            {config.BIZSOL_DISPLAY_NAME}
          </Font>
        </div>
        <div css={inputWrapper}>
          {showCancelWaitingButton && (
            <CancelBizsolWaitingButton
              onClick={onClickCancelWaiting}
              loading={loading}
            />
          )}
          {showChangeToWaitingButton && (
            <ChangeBizsolStateToWaitingButton
              onClick={onClickChangeToWaiting}
              loading={loading}
            />
          )}
          {showReconnectButton && (
            <BizsolReconnectButton
              onClick={onClickReconnect}
              loading={loading}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
  alignItems: "center",
});

const labelWrapper = css({
  width: "200px",
  marginRight: "15px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  width: "100%",
  paddingTop: "8px",
});
